import { motion } from "framer-motion";
import { Target, Eye, TrendingUp } from "lucide-react";
import { MISSION, VISION, VALUES } from "@/components/laneeka/data";

export default function VisionPage() {
  return (
    <main data-testid="vision-page" className="pt-[108px]">
      <section className="bg-slate-50 border-b border-slate-200 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-3">About</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Our vision &amp; mission</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
          <motion.div data-testid="vision-card" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="border border-slate-200 rounded-xl p-8">
            <Eye className="w-7 h-7 text-blue-700 mb-4" strokeWidth={1.75} />
            <h2 className="text-xl font-bold text-slate-900 mb-3">Vision</h2>
            <p className="text-slate-600 leading-relaxed">{VISION}</p>
          </motion.div>
          <motion.div data-testid="mission-card" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}
            className="border border-slate-200 rounded-xl p-8">
            <Target className="w-7 h-7 text-blue-700 mb-4" strokeWidth={1.75} />
            <h2 className="text-xl font-bold text-slate-900 mb-3">Mission</h2>
            <p className="text-slate-600 leading-relaxed">{MISSION}</p>
          </motion.div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.15 }}
            className="bg-slate-50 border border-slate-200 rounded-xl p-8">
            <TrendingUp className="w-7 h-7 text-blue-700 mb-4" strokeWidth={1.75} />
            <h2 className="text-xl font-bold text-slate-900 mb-3">From tough beginnings to industry leaders</h2>
            <p className="text-slate-600 leading-relaxed max-w-3xl">
              In an industry as essential as industrial belting, selecting the right partner can make all the
              difference. We are proud to stand out as the premier choice for businesses seeking reliability,
              efficiency, and exceptional service in their belting solutions — driving their operations forward
              with innovative and tailored support.
            </p>
            <div className="mt-6 flex flex-wrap gap-2" data-testid="vision-values">
              {VALUES.map((v) => (
                <span key={v} className="text-xs font-semibold bg-white border border-slate-200 text-slate-700 px-3 py-1.5 rounded-full">{v}</span>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
